import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { NavigationEnd } from '@angular/router';
import { AutoLoginService } from './autoLoginService';
declare var swal: any;  //For Sweet Alert
@Component({
  selector: 'app-auto-login',
  templateUrl: './auto-login.component.html',
  providers: [AutoLoginService]
})

export class AutoLoginComponent {
  public accessKey:any;

  constructor(private autoLoginService: AutoLoginService, private activatedRoute: ActivatedRoute, private router: Router) {
    this.activatedRoute.queryParams.subscribe(params => {
      this.accessKey = params.token;
      this.navPage();
    });
  }

  navPage() {
    this.autoLoginService.getLogin(this.accessKey).subscribe(posts => {
      if (posts.status == '1') {
        swal({ title: "Success!", text:"Signup Successful", type: 'success',});
        this.router.navigate(['login']);
      } else {
        swal({ title: "Invalid Login", type: 'warning',})
        this.router.navigate(['login']);
      }
    });
  }

  ngOnInit() {
  }
}


// WEBPACK FOOTER //
// ./src/app/autoLogin/autoLoginComponent.ts